import { render } from "./milestone-tooltip-progress-indicator.vue?vue&type=template&id=ddbbf172&scoped=true&ts=true"
import script from "./milestone-tooltip-progress-indicator.vue?vue&type=script&lang=ts"
export * from "./milestone-tooltip-progress-indicator.vue?vue&type=script&lang=ts"

import "./milestone-tooltip-progress-indicator.vue?vue&type=style&index=0&id=ddbbf172&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddbbf172"]])

export default __exports__